/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addUserToGroup } from '../fn/groups/add-user-to-group';
import { AddUserToGroup$Params } from '../fn/groups/add-user-to-group';
import { createGroup } from '../fn/groups/create-group';
import { CreateGroup$Params } from '../fn/groups/create-group';
import { deleteGroup } from '../fn/groups/delete-group';
import { DeleteGroup$Params } from '../fn/groups/delete-group';
import { getGroup } from '../fn/groups/get-group';
import { GetGroup$Params } from '../fn/groups/get-group';
import { GroupCollaboratorDtoPage } from '../models/group-collaborator-dto-page';
import { GroupDto } from '../models/group-dto';
import { GroupDtoPage } from '../models/group-dto-page';
import { GroupUserAddableDtoPage } from '../models/group-user-addable-dto-page';
import { GroupUserDtoPage } from '../models/group-user-dto-page';
import { listGroupCollaborators } from '../fn/groups/list-group-collaborators';
import { ListGroupCollaborators$Params } from '../fn/groups/list-group-collaborators';
import { listGroups } from '../fn/groups/list-groups';
import { ListGroups$Params } from '../fn/groups/list-groups';
import { listGroupUsers } from '../fn/groups/list-group-users';
import { ListGroupUsers$Params } from '../fn/groups/list-group-users';
import { listGroupUsersAddable } from '../fn/groups/list-group-users-addable';
import { ListGroupUsersAddable$Params } from '../fn/groups/list-group-users-addable';
import { removeUserFromGroup } from '../fn/groups/remove-user-from-group';
import { RemoveUserFromGroup$Params } from '../fn/groups/remove-user-from-group';
import { updateGroup } from '../fn/groups/update-group';
import { UpdateGroup$Params } from '../fn/groups/update-group';

@Injectable({ providedIn: 'root' })
export class GroupsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listGroups()` */
  static readonly ListGroupsPath = '/v0/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroups$Response(params?: ListGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupDtoPage>> {
    return listGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroups(params?: ListGroups$Params, context?: HttpContext): Observable<GroupDtoPage> {
    return this.listGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupDtoPage>): GroupDtoPage => r.body)
    );
  }

  /** Path part for operation `getGroup()` */
  static readonly GetGroupPath = '/v0/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroup$Response(params: GetGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupDto>> {
    return getGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroup(params: GetGroup$Params, context?: HttpContext): Observable<GroupDto> {
    return this.getGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupDto>): GroupDto => r.body)
    );
  }

  /** Path part for operation `updateGroup()` */
  static readonly UpdateGroupPath = '/v0/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroup$Response(params: UpdateGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroup(params: UpdateGroup$Params, context?: HttpContext): Observable<void> {
    return this.updateGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createGroup()` */
  static readonly CreateGroupPath = '/v0/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGroup$Response(params: CreateGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupDto>> {
    return createGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGroup(params: CreateGroup$Params, context?: HttpContext): Observable<GroupDto> {
    return this.createGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupDto>): GroupDto => r.body)
    );
  }

  /** Path part for operation `deleteGroup()` */
  static readonly DeleteGroupPath = '/v0/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGroup$Response(params: DeleteGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGroup(params: DeleteGroup$Params, context?: HttpContext): Observable<void> {
    return this.deleteGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addUserToGroup()` */
  static readonly AddUserToGroupPath = '/v0/groups/{id}/add-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addUserToGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addUserToGroup$Response(params: AddUserToGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addUserToGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addUserToGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addUserToGroup(params: AddUserToGroup$Params, context?: HttpContext): Observable<void> {
    return this.addUserToGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeUserFromGroup()` */
  static readonly RemoveUserFromGroupPath = '/v0/groups/{id}/remove-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeUserFromGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeUserFromGroup$Response(params: RemoveUserFromGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeUserFromGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeUserFromGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeUserFromGroup(params: RemoveUserFromGroup$Params, context?: HttpContext): Observable<void> {
    return this.removeUserFromGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listGroupUsersAddable()` */
  static readonly ListGroupUsersAddablePath = '/v0/groups/group-users-addable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGroupUsersAddable()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroupUsersAddable$Response(params: ListGroupUsersAddable$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupUserAddableDtoPage>> {
    return listGroupUsersAddable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGroupUsersAddable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroupUsersAddable(params: ListGroupUsersAddable$Params, context?: HttpContext): Observable<GroupUserAddableDtoPage> {
    return this.listGroupUsersAddable$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupUserAddableDtoPage>): GroupUserAddableDtoPage => r.body)
    );
  }

  /** Path part for operation `listGroupUsers()` */
  static readonly ListGroupUsersPath = '/v0/groups/group-users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGroupUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroupUsers$Response(params: ListGroupUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupUserDtoPage>> {
    return listGroupUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGroupUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroupUsers(params: ListGroupUsers$Params, context?: HttpContext): Observable<GroupUserDtoPage> {
    return this.listGroupUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupUserDtoPage>): GroupUserDtoPage => r.body)
    );
  }

  /** Path part for operation `listGroupCollaborators()` */
  static readonly ListGroupCollaboratorsPath = '/v0/groups/group-collaborators';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGroupCollaborators()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroupCollaborators$Response(params: ListGroupCollaborators$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupCollaboratorDtoPage>> {
    return listGroupCollaborators(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGroupCollaborators$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGroupCollaborators(params: ListGroupCollaborators$Params, context?: HttpContext): Observable<GroupCollaboratorDtoPage> {
    return this.listGroupCollaborators$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupCollaboratorDtoPage>): GroupCollaboratorDtoPage => r.body)
    );
  }

}
